import { useQuery } from "@tanstack/react-query";
import { zohoApi } from "zohoApi";
import { useZohoAuthContext } from "context/ZohoAuthContext";

const STALE_TIME = 60 * 60 * 1000; // 1 hour

export const useCalenderConfig = () => {
  const { orgId, apiKey, dataCenterUrl } = useZohoAuthContext();

  const { data: calenderConfig, isPending } = useQuery({
    queryKey: ["calenderConfig"],
    staleTime: STALE_TIME,
    enabled: Boolean(orgId && apiKey && dataCenterUrl),
    queryFn: async () => {
      const { data } = await zohoApi?.config?.getConfigFromDB({
        orgId,
        apiKey,
        dataCenterUrl,
        settingApiName: "calenderConfig",
      });

      const el = data?.[0] || {};

      const obj = {
        ...JSON.parse(el?.setting_schema || "{}"),
        setting_id: el?.setting_id,
      };

      return obj;
    },
  });

  return { calenderConfig, isPending };
};
